import type { SecretaryScope } from './scopes';

export interface SecretaryDoctor {
  id: string;
  name: string | null;
  scopes: SecretaryScope[];
}

/** one doctor → act for them at once; several → keep the stored choice (a picker sets it) if it is still valid */
export const pickActingDoctor = (doctors: SecretaryDoctor[], stored: string | null): SecretaryDoctor | null =>
  doctors.find(doctor => doctor.id === stored) ?? (doctors.length === 1 ? doctors[0] : null);
